import React from 'react';

const RatingDisplay = ({ averageRating, totalRatings }) => {
  const renderStar = (index) => {
    if (averageRating >= index) {
      return <FullStar key={index} />;
    } else if (averageRating >= index - 0.5) {
      return <HalfStar key={index} />;
    } else {
      return <EmptyStar key={index} />;
    }
  };

  return (
    <div style={containerStyle}>
      <div style={starsStyle}>
        {[1, 2, 3, 4, 5].map((i) => renderStar(i))}
      </div>
     {totalRatings=='na'?'': <span style={textStyle}>({totalRatings} ratings)</span>}
    </div>
  );
};

// SVG Components

const starBaseStyle = {
  width: '19px',
  height: '19px',
  marginRight: '4px',
  flexShrink: 0,
};

const FullStar = () => (
  <svg viewBox="0 0 24 24" fill="#facc15" style={starBaseStyle}>
    <path d="M12 2l2.9 6.9 7.1 1-5.2 5.1 1.2 7-6-3.5-6 3.5 1.2-7L2 9.9l7.1-1L12 2z" />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" style={starBaseStyle}>
    <defs>
      <linearGradient id="half-grad">
        <stop offset="50%" stopColor="#facc15" />
        <stop offset="50%" stopColor="#e5e7eb" />
      </linearGradient>
    </defs>
    <path
      d="M12 2l2.9 6.9 7.1 1-5.2 5.1 1.2 7-6-3.5-6 3.5 1.2-7L2 9.9l7.1-1L12 2z"
      fill="url(#half-grad)"
    />
  </svg>
);

const EmptyStar = () => (
  <svg viewBox="0 0 24 24" fill="#e5e7eb" style={starBaseStyle}>
    <path d="M12 2l2.9 6.9 7.1 1-5.2 5.1 1.2 7-6-3.5-6 3.5 1.2-7L2 9.9l7.1-1L12 2z" />
  </svg>
);

// Inline Styles

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
  padding:'5px 7px',
  marginLeft: '-10px',
};

const starsStyle = {
  display: 'flex',
  alignItems: 'center',
  
};

const textStyle = {
  fontSize: '0.8rem',
  fontWidth:'311',
  color: '#999',
  textDecoration:'none'
};

export default RatingDisplay;
